module.exports = __webpack_public_path__ + "static/media/mobile-pos.7f24d27f.png";